module.exports = __webpack_public_path__ + "assets/img/hbjx.3c4c55bb.png";